import React, { forwardRef, useState, useCallback } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { UiActioButton } from "./ui";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Popover from 'react-bootstrap/Popover';
import { useDropzone } from 'react-dropzone';
import { instance } from "./axios";
import { toast } from "react-toastify";
import { BsUpload, BsInfoCircle } from 'react-icons/bs';
import { AiOutlineFile } from 'react-icons/ai';
import { MdOutlineVisibility, MdOutlineVisibilityOff, MdFileDownload, MdOutlineDelete } from 'react-icons/md';
import enGB from 'date-fns/locale/en-GB';
import formatRelative from 'date-fns/formatRelative'
import Swal from "sweetalert2";
import { parse } from 'date-fns';
import { TiFlowChildren } from "react-icons/ti";
import { Link } from "react-router-dom";


export function BasicUploader(props) {
  const { setMyFiles, myFiles, uid, category, ...other } = props;
  const [error, setError] = useState([]);
  const [state, setState] = useState({});

  const onDrop = useCallback(acceptedFiles => {
    setMyFiles([...myFiles, ...acceptedFiles])
  }, [myFiles])


  const { acceptedFiles, getRootProps, fileRejections, getInputProps } = useDropzone({
    // Note how this callback is never invoked if drop occurs on the inner dropzone
    // onDrop: files => handleSave1(files),
    onDrop,
    maxSize: 5242880,
    // maxSize: 200,
    accept: {
      'application/vnd.ms-excel': ['.xls', '.xlsx'],
      'application/pdf': ['.pdf'],
      'text/csv': ['.csv'],
      'application/msword': ['.doc', '.docx'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],

    }
  });


  const removeFile = file => () => {
    const newFiles = [...myFiles]
    newFiles.splice(newFiles.indexOf(file), 1)
    setMyFiles(newFiles)
  }


  const files = myFiles.map(file => (
    <div className="d-flex justify-content-between list1" key={file.path}>
      <span>{file.path} </span>
      <UiActioButton action={removeFile(file)} title="Delete">Remove File</UiActioButton>
    </div>
  ))




  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <div className="alert alert-danger mt-3" role="alert" key={file.path}>
      <b>{file.path}</b><br></br>

      {errors.map(e => (
        <span key={e.code}>○ {e.code == 'file-invalid-type' && 'Invalid file type'}{e.code == 'file-too-large' && 'File is large (Max. 5MB)'} </span>
      ))}

    </div>
  ));


  return (
    <div>
      <div className="position-relative">
        <div className="">
          <div {...getRootProps({ className: 'dropzone uploadbox' })} >
            <input {...getInputProps()} />
            <span className="fs-3 text-primary">
              <BsUpload />
            </span>
            <p className="text-dark pe-none">Drop files here or click to choose.</p>
            <small className="text-muted">Maximum File Size: 5 MB  |  File Format: CSV, XLS, XLSX, DOC, PDF, JPG</small>
          </div>
        </div>

        {files && files.length > 0 && (

          <div className="mt-3">
            <b>Selected files</b>
            {files}
          </div>
        )}
        {fileRejectionItems}
      </div>

    </div>
  );
}

